<!-- //
remote下拉检索
@author xuyd
@date 2024-5-2
//-->
<template>
  <div>
    <el-select
        style="width: 100%;"
        filterable
        clearable
        remote
        :size="options.size"
        :placeholder="placeholder"
        :popper-class="popperClass"
        :remote-method="handleRemoteMethod"
        :multiple="multiple"
        v-model="inputData"
        @change="handleChange">
      <el-option
          v-for="(item, index) in dataSource"
          :key="index"
          :value="item[options.value]"
          :label="item[options.label] + '(' + item[options.value] + ')'"/>
    </el-select>
  </div>
</template>
<script>

export default {
  name: 'CompSelectorRemote',
  data() {
    return {
      dataSource: [...this.datasourceList],
      inputData: this.value,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          size: 'small',
          value: 'dictValue',
          label: 'dictLabel'
        }
      }
    },
    value: [String, Number],
    datasourceList:  {
      type: Array,
      default: () => {
        return [];
      },
    },
    multiple: {// 多选
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入关键字搜索",
    },
    popperClass: String,
    remoteMethod: Function,
  },
  watch: {
    value: {
      handler(val) {
        this.inputData = val;
      },
      immediate: true
    },
  },
  methods: {
    /**
     * API调用
     */
    handleRemoteMethod(val) {
      this.remoteMethod(val).then(resp => {
        // console.log("-------searchUserList-------",val, JSON.stringify(data))
        this.dataSource = resp.data;
      })
    },

    handleChange(val) {
      console.log("-------handleChange-------", val);
      let item = this.dataSource.find(item => item[this.options.value] === val);
      this.$emit('change', val, item || {})
    },
  }
}
</script>

<style lang="less" scoped>
</style>
